import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { NgxEventCalendarModule } from 'ngx-event-calendar';
import { CoreModule } from './core/core.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app/app.component';
import { FaqsComponent } from './faqs/faqs.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { CommonModule, DatePipe } from '@angular/common';
import { HttpClient, HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LayoutModule } from '@angular/cdk/layout';
import { MatListModule } from '@angular/material/list';
import { LoginComponent } from './login/login.component';
import { RegistrationComponent } from './registration/registration.component';
import { ForgotResetPassComponent } from './forgot-reset-pass/forgot-reset-pass.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { DepartmentCommunityHallModuleComponent } from './Community Hall Department Module/department-community-hall-module/department-community-hall-module.component';
import { DepComHallPolicyMasterComponent } from './Community Hall Department Module/dep-com-hall-policy-master/dep-com-hall-policy-master.component';
import { DepComHallSocDebBookingComponent } from './Community Hall Department Module/dep-com-hall-soc-deb-booking/dep-com-hall-soc-deb-booking.component';
import { DepComHallVerOfSocComponent } from './Community Hall Department Module/dep-com-hall-ver-of-soc/dep-com-hall-ver-of-soc.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { LoaderInterceptor } from './service/loader.interceptor';
import { MaterialDesignModule } from './material-design/material-design.component';
import { RwaRegPublishFormComponent } from './RWAModule/Rwa Registration/rwa-reg-publish-form/rwa-reg-publish-form.component';
import { AchievementComponent } from './features/about/achievement/achievement.component';
import { AnnualReportsComponent } from './features/about/annual-reports/annual-reports.component';
import { CircularComponent } from './features/about/circular/circular.component';
import { ImportantlinksComponent } from './features/about/importantlinks/importantlinks.component';
import { OrganizationChartComponent } from './features/about/organization-chart/organization-chart.component';
import { TenderComponent } from './features/about/tender/tender.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { OtpLoginComponent } from './otp-login/otp-login.component';
import { DeptLoginComponent } from './dept-login/dept-login.component';
import { GlobalpaymentresponseComponent } from './globalpaymentresponse/globalpaymentresponse.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import jsPDF from 'jspdf';
import { OnlineBookingComponent } from './online-booking/online-booking.component';
import { NgxPrintModule } from 'ngx-print';
import { CopyrightComponent } from './copyright/copyright.component';
import { TermandconditionComponent } from './copyright/termandcondition/termandcondition.component';
import { PrivacyComponent } from './copyright/privacy/privacy.component';
import { DisclamerComponent } from './copyright/disclamer/disclamer.component';
import { HyperlinkComponent } from './copyright/hyperlink/hyperlink.component';
import { WebinfoComponent } from './copyright/webinfo/webinfo.component';
import { HelpComponent } from './copyright/help/help.component';
import { AboutUsComponent } from './copyright/about-us/about-us.component';
import { ContactUsComponent } from './copyright/contact-us/contact-us.component';
import { ContentArchivalComponent } from './copyright/content-archival/content-archival.component';
import { ContentReviewComponent } from './copyright/content-review/content-review.component';
import { CampComponent } from './copyright/camp/camp.component';
import { CamwebsiteMonitoringComponent } from './copyright/camwebsite-monitoring/camwebsite-monitoring.component';
import { SecurityComponent } from './copyright/security/security.component';
import { ContingencyComponent } from './copyright/contingency/contingency.component';
import { SitemapComponent } from './copyright/sitemap/sitemap.component';
import { FeedbackComponent } from './copyright/feedback/feedback.component';
import { RejectDepartmentDialogComponent } from './reject-department-dialog/reject-department-dialog.component';
import { PublicHearingManualComponent } from './copyright/public-hearing-manual/public-hearing-manual.component';
import { PhFeedbackComponent } from './copyright/ph-feedback/ph-feedback.component';
import { LrDashboardComponent } from './copyright/lr-dashboard/lr-dashboard.component';





@NgModule({
  entryComponents: [


  ],

  imports: [

    // angular

    BrowserAnimationsModule,
    BrowserModule,

    NgxEventCalendarModule,

    // core
    CoreModule,
    CommonModule,
    // app
    AppRoutingModule,

    HttpClientModule,
    OverlayModule,

    FontAwesomeModule,

    MatNativeDateModule,


    LayoutModule,


    MatListModule,

    MaterialDesignModule,
    AngularEditorModule,
    NgxPrintModule,
    
    
    
  ],
  declarations: [

    AppComponent,

    LoginComponent, RegistrationComponent,
    ForgotResetPassComponent,
    ResetPasswordComponent,

    ForgotPasswordComponent,

    DepartmentCommunityHallModuleComponent,

    DepComHallPolicyMasterComponent,

    DepComHallSocDebBookingComponent,

    DepComHallVerOfSocComponent,
    RwaRegPublishFormComponent,
    FaqsComponent, AchievementComponent,
    AnnualReportsComponent,
    CircularComponent,
    ImportantlinksComponent,
    OrganizationChartComponent,
    TenderComponent,
    PageNotFoundComponent,
   
    OtpLoginComponent,
   
    DeptLoginComponent,
   
    GlobalpaymentresponseComponent,
   
    OnlineBookingComponent,
   
    CopyrightComponent,
   
    TermandconditionComponent,
   
    PrivacyComponent,
   
    DisclamerComponent,
   
    HyperlinkComponent,
   
    WebinfoComponent,
   
    HelpComponent,
   
    AboutUsComponent,
   
    ContactUsComponent,
   
    ContentArchivalComponent,
   
    ContentReviewComponent,
   
    CampComponent,
   
    CamwebsiteMonitoringComponent,
   
    SecurityComponent,
   
    ContingencyComponent,
   
    SitemapComponent,
   
    FeedbackComponent,
   
    RejectDepartmentDialogComponent,
   
    PublicHearingManualComponent,
   
    PhFeedbackComponent,
   
    LrDashboardComponent,

  
   
   
   
   
   
   
  
   
    
  ],

  bootstrap: [AppComponent
  ],

  providers: [DatePipe, { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },

  ]
})
export class AppModule { }
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}